import { useMutation, useQueryClient } from '@tanstack/react-query';
import { operations } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

export type ConfirmBankAccountVerificationResponse =
  operations['createSupplierIntegrationConfirmVerification']['responses'][201]['content']['application/json'];

export type BankAccountVerificationStatus = ConfirmBankAccountVerificationResponse['data']['status'];

const useConfirmBankAccountVerification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['confirmBankAccountVerification'],
    mutationFn: (bankAccountUuid: string) => {
      return apiClient
        .post(`api/supplier-experience/bank-accounts/${bankAccountUuid}/confirm-verification`)
        .json<ConfirmBankAccountVerificationResponse>();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companyStatus'] });
    },
  });
};

export default useConfirmBankAccountVerification;
